import { render, staticRenderFns } from "./totalRank.vue?vue&type=template&id=4dcc98ed&"
import script from "./totalRank.vue?vue&type=script&lang=js&"
export * from "./totalRank.vue?vue&type=script&lang=js&"
import style0 from "./totalRank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports